import React from 'react';

import NoItemsInList from '../../../components/NoItemsInList';
import usePartnerLogs from '../../../api/usePartnerLogs';
import Scrollable from '../../../components/Scrollable';
import { formattedDateTime } from '../../../utils/date';
import Loader from '../../../components/Loader';
import { useFilter } from './context';
import {
  ActivityTableFooter,
  ActivityTableRow,
  ActivityTable,
  StatusBadge,
  VerifiedDot,
  MethodTag
} from '../styledComponents';

const formatMs = (ms) => {
  if (ms == null) return '–';
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
  return `${ms}ms`;
};

export default function LogsTable({ partnerId }) {
  const filter = useFilter();
  const { items, total, hasMore, isLoading, isLoadingMore, setSize } = usePartnerLogs({
    partnerId,
    filter
  });

  const handleLoadMore = () => {
    if (!isLoading && !isLoadingMore && hasMore) {
      setSize((s) => s + 1);
    }
  };

  return (
    <ActivityTable>
      <ActivityTableRow head type='requests'>
        <div>Time</div>
        <div>Method</div>
        <div>Endpoint</div>
        <div>Client</div>
        <div>App</div>
        <div>VIN</div>
        <div>Status</div>
        <div>Verified</div>
        <div>Response</div>
      </ActivityTableRow>

      <Scrollable isLoading={isLoading || isLoadingMore} bottomReached={handleLoadMore}>
        {items.length > 0 ? (
          items.map((row) => (
            <ActivityTableRow key={row.id} type='requests'>
              <div title={row.createdAt}>{formattedDateTime(row.createdAt)}</div>
              <div>
                <MethodTag>{row.method}</MethodTag>
              </div>
              <div title={row.endpoint}>{row.endpoint}</div>
              <div title={row.clientInfo}>{row.clientInfo}</div>
              <div title={row.appInfo}>{row.appInfo}</div>
              <div title={row.vin}>{row.vin || '–'}</div>
              <div>
                <StatusBadge status={row.httpStatus}>{row.httpStatus}</StatusBadge>
              </div>
              <div>
                <VerifiedDot verified={row.isVerified} />
                {row.isVerified ? 'Yes' : 'No'}
              </div>
              <div>{formatMs(row.responseTimeMs)}</div>
            </ActivityTableRow>
          ))
        ) : (
          <NoItemsInList>{!isLoading ? 'No logs to show' : ''}</NoItemsInList>
        )}
      </Scrollable>

      {items.length > 0 && (
        <ActivityTableFooter>
          Showing {items.length} of {total}
        </ActivityTableFooter>
      )}

      <Loader isLoading={isLoading || isLoadingMore} firstLoad={!items.length} />
    </ActivityTable>
  );
}
